import { setMatchNotificationTypes } from './handlers';
import { dispatch } from 'nike-re-framejs';

let notificationClient;
let log = function() {
    const args = Array.prototype.slice.call(arguments);
    args.unshift('[nike-notification-server-api]');
    console.log.apply(null, args);
};
let getContext;

/* === DEFAULTNE PARAMETRE NOTIFY VOLANI === */
let channel = 'MOBILE';
const osType = 'WEB';
const deviceDescription = navigator.userAgent;

export function init(channelName, axiosClient, getContextFunction, logFunction) {
    channel = channelName;
    notificationClient = axiosClient;
    getContext = getContextFunction;
    log = logFunction || log;
}

/* === SUBSCRIPTIONS === */
export function loadSubscriptions() {
    log('loadSubscriptions');
    return notificationClient.get('subscriptions');
}

/* === DEVICES === */
export function pairDevice(deviceToken) {
    log('pairDevice', deviceToken);
    return notificationClient.post('devices', {
        deviceToken,
        deviceDescription,
        osType,
        channel
    });
}

export function updateDeviceToken(oldDeviceToken, newDeviceToken) {
    log('updateDeviceToken', { oldDeviceToken, newDeviceToken });
    return notificationClient.put(`devices/${oldDeviceToken}`, { deviceToken: newDeviceToken });
}

/* === CUSTOMER NOTIFICATIONS === */
export function updateCustomerSubscription(type, value) {
    const deviceToken = getContext().token;
    log('updateCustomerSubscription', { type, value, deviceToken });
    if (value) {
        return notificationClient.post('subscriptions/customer', {
            type,
            deviceToken,
            deviceDescription,
            osType,
            channel
        });
    }
    return notificationClient.delete(`subscriptions/customer/${type}`);
}

/* === BETBOOK NOTIFICATIONS === */
export function subscribeToBetbookAuthor(authorNickname) {
    log('subscribeToBetbookAuthor', authorNickname);
    return notificationClient.post('subscriptions/betbook', {
        authorNickname,
        analysesTracking: true,
        blogsTracking: true,
        ticketsTracking: true,
        deviceToken: getContext().token,
        deviceDescription,
        osType,
        channel
    });
}

export function unsubscribeFromBetbookAuthor(authorNickname) {
    log('unsubscribeFromBetbookAuthor', authorNickname);
    return notificationClient.delete(`subscriptions/betbook/${authorNickname}`);
}

/* === MATCH NOTIFICATIONS === */
export function loadMatchSubscriptionTypes(eventId) {
    log('loadMatchSubscriptionTypes', eventId);
    return notificationClient.get(`subscriptions/match/${eventId}/types`);
}

export function subscribeToMatch(eventId, types) {
    log('subscribeToMatch', { eventId, types });
    return notificationClient.put(`subscriptions/match/${eventId}`, {
        eventId,
        types,
        deviceToken: getContext().token,
        deviceDescription,
        osType,
        channel
    });
}

/* === TICKET NOTIFICATIONS === */
export function loadTicketSubscriptions() {
    log('getTicketsSubscriptions');
    return notificationClient.get('subscriptions/ticket');
}

export function subscribeToTicket(ticketId, ticketTracking, picksTracking) {
    log('subscribeToTicket', ticketId);
    return notificationClient.post('subscriptions/ticket', {
        ticketId,
        ticketTracking,
        picksTracking,
        deviceToken: getContext().token,
        deviceDescription,
        osType,
        channel
    });
}

export function unsubscribeFromTicket(ticketId) {
    log('unsubscribeFromTicket', ticketId);
    return notificationClient.delete(`subscriptions/ticket/${ticketId}`);
}

export function getMatchSubscriptionTypes(eventId) {
    loadMatchSubscriptionTypes(eventId)
        .then((matchTypes = []) => {
            dispatch(setMatchNotificationTypes(eventId, matchTypes));
        })
        .catch(() => {
            dispatch(setMatchNotificationTypes(eventId, []));
        });
}
